import { CarouselAutoplayControl, CarouselButton } from 'react-aria-carousel';
import styled, { css } from 'styled-components';

const buttonBase = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:focus-visible {
    outline: 0;
    box-shadow: var(--shadow-focus);
  }

  &:disabled,
  &[aria-disabled='true'] {
    color: var(--grey-400);
    cursor: not-allowed;
  }
`;

export const ControlButton = styled(CarouselButton)`
  ${buttonBase}
  width: 44px;
  height: 44px;
  padding: 0;
  background: var(--white);
  border: 1px solid var(--grey-300);
  border-radius: var(--radius-large);
  color: var(--black);
  transition: background 0.15s ease, border-color 0.15s ease;

  & svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    background: var(--grey-50);
    border-color: var(--grey-400);
  }

  &:disabled,
  &[aria-disabled='true'] {
    border-color: var(--grey-200);
    background: var(--grey-50);
  }
`;

export const PlayPause = styled(CarouselAutoplayControl)`
  ${buttonBase}
  background: var(--grey-100);
  border: 1px solid var(--grey-300);
  padding: 4px;
  margin: 0;
  color: var(--black);
  border-radius: 6px;
  transition: color 0.15s ease, background 0.15s ease, border-color 0.15s ease;

  & svg {
    width: 22px;
    height: 22px;
    flex: 0 0 22px;
  }

  &:hover {
    background: var(--grey-200);
    border-color: var(--grey-400);
  }
`;

export const FloatingArrow = styled(CarouselButton)`
  ${buttonBase}
  width: 30px;
  height: 30px;
  padding: 0;
  background: var(--white);
  border: 1px solid var(--black);
  color: var(--black);
  border-radius: 999px;
  position: absolute;
  top: 140px;
  transform: translateY(-50%);
  z-index: 2;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  & svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    background: var(--grey-50);
  }

  &:disabled,
  &[aria-disabled='true'] {
    border-color: var(--grey-300);
    background: var(--grey-50);
  }

  &[data-direction='prev'] {
    left: 0;
  }
  &[data-direction='next'] {
    right: 0;
  }

  @media (width < 48rem) {
    display: none;
  }

  .surface-zest-green & {
    background: var(--grey-50);
  }

  .surface-moss-green & {
    background: var(--white);
    border-color: var(--grey-300);
    color: var(--black);
  }
`;

export const Cluster = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;
